
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import TextField from '@/components/shared/TextField.vue';

@Component<TagLocaleEditor>({
	components: {
		TextField
	}
})
export default class TagLocaleEditor extends Vue {
	@Prop({ type: Object, default: () => {} }) private tag!: MenuItemTag;
	@Prop({ type: Object, default: () => {} }) private selectedLocale!: RestaurantLocale;
	@Prop({ type: Boolean, default: false }) private disabled!: boolean;
	@Prop({ type: Boolean, default: false }) private valid!: boolean;
	@Watch('selectedLocale')
	onSelectedLocaleUpdate() {
		if(this.selectedLocale && !this.selectedLocale.is_default) {
			this.mutableTag.localization = this.mutableTag.localization ? this.mutableTag.localization : {} as Localization;

			if(!this.mutableTag.localization[this.selectedLocale.locale_short]) {
				this.mutableTag.localization[this.selectedLocale.locale_short] = {
					name: ''
				};
			}
		}
	}

	private mutableTag: MenuItemTag = this.tag;
}
